import { render } from "./FormGroup.vue?vue&type=template&id=0ee20904"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__